export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('nightRange');
    if (element) {
        tourCriteriaJson.nightRange = {};
        const from = element.get('from');
        const to = element.get('to');
        if (from) {
            tourCriteriaJson.nightRange.from = from;
        }
        if (to) {
            tourCriteriaJson.nightRange.to = to;
        }
    }

    return tourCriteriaJson;
};